const isInnerLink = (url: string): boolean => {
    return url.includes('inner-navigation')
}

export default isInnerLink
